import script from "./money-change-record.vue?vue&type=script&setup=true&lang=js"
export * from "./money-change-record.vue?vue&type=script&setup=true&lang=js"

import "./money-change-record.vue?vue&type=style&index=0&id=7693d290&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7693d290"]])

export default __exports__